/*
Reading the failures of the public link endpoints (XOL-602/603/604): POST /password/forgot,
/password/token, /password/reset, /registration/invite, /registration/invite/accept.

Shared by ResetPassword and InviteRegister. Pure; no component state.

THE CODE, NOT THE SENTENCE. A 410 carries `{code, message}`. The pages key on `code`; the
`message` is plain English for a human reading a network trace and is never shown or parsed.
An unknown code reads as `invalid`, the safest wording ("ask for a new link").

A 410 IS NOT A SESSION FAILURE. These endpoints never answer 401 for a bad token (a 401 would
start the axios client's refresh-or-forced-logout), so a link page has nothing to do with the
session, and must never call redirectToLogin / endSession for any of these answers.

ES5, no optional chaining or nullish coalescing (Babel 6).
------------------------------------------------------------------------ */

var LINK_CODES = ['expired', 'used', 'invalid', 'account_unavailable', 'email_in_use']

export function errStatus (err) {
  return err && err.response && typeof err.response.status === 'number' ? err.response.status : null
}

export function errBody (err) {
  var data = err && err.response ? err.response.data : null
  return (data && typeof data === 'object') ? data : {}
}

// The 410 `code`, or 'invalid' for one we do not know.
export function linkCode (err) {
  var code = errBody(err).code
  return LINK_CODES.indexOf(code) !== -1 ? code : 'invalid'
}

// The first message for `field` in a Laravel 422 `{message, errors:{field:[...]}}`, or ''.
export function fieldMessage (err, field) {
  var errors = errBody(err).errors
  var list = errors && errors[field]
  return (list && list.length && typeof list[0] === 'string') ? list[0] : ''
}

// axios-retry replays a POST on a 5xx / network error. If the first attempt committed and
// its answer was lost, the replay meets a used-up link and gets 410 `used`. The retry count
// lives on the request config; a page that sees `used` after a retry cannot tell "someone
// else used it" from "I did, a moment ago", and must say so.
export function wasRetried (err) {
  var state = err && err.config ? err.config['axios-retry'] : null
  return !!(state && state.retryCount > 0)
}
